// src/app/signal-cards/signal-cards.component.ts
import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

// Definisci l'interfaccia per la struttura dei dati dei segnali che riceverai
interface SignalData {
    selectModel: string;
    modelLabel: string;
    tableRows: {
        Name: string;
        description: string;
        Unit: string;
    }[];
}

// Definisci l'interfaccia per le proprietà specifiche del tuo custom type
interface SignalCardsProps {
    signalData: SignalData[]; // Array con la struttura dei tuoi dati segnali
    // Puoi aggiungere altre proprietà qui se necessario
}

@Component({
    selector: 'app-signal-cards',
    styleUrls: ['../../config-page/config-page.component.scss'],
    template: `
            <div class="signal-cards-container mt20 mB10">
                <div>
                    <h4><strong>{{'global.saveSignal' | translate}}</strong></h4>
                </div>

                <div *ngFor="let modelData of field.props?.signalData" class="signal-card">
                    <div class="card-header flex justify-between items-center" (click)="toggleModel(modelData.selectModel)" style="cursor: pointer;">
                        <h4 class="card-title m-0">
                            {{ modelData.modelLabel }}
                            <span style="float: right;">
                                <i [class]="activeModel === modelData.selectModel ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                            </span>
                        </h4>
                    </div>

                    <div class="card-body" *ngIf="activeModel === modelData.selectModel">
                        <div *ngFor="let signal of modelData.tableRows" class="form-check">
                            <input class="form-check-input" type="checkbox"
                                [id]="field.id + '-' + modelData.selectModel + '-' + signal.Name" [value]="signal.Name"
                                [checked]="isChecked(modelData.selectModel, signal.Name)"
                                (change)="onCheckboxChange(modelData.selectModel, signal.Name, $event)">
                            <label class="form-check-label" [for]="field.id + '-' + modelData.selectModel + '-' + signal.Name">
                                {{ signal.description }} ({{ signal.Unit }})
                            </label>
                        </div>
                    </div>
                </div>
            </div>`,
})
export class SignalCardsComponent extends FieldType<FieldTypeConfig<SignalCardsProps>> {
    activeModel: string | null = null;
    isChecked(selectModelKey: string, signalKey: string): boolean {
        const selectedValues = this.formControl.value as { [key: string]: string[] };
        if (!selectedValues || !selectedValues[selectModelKey]) {
            return false;
        }
        return selectedValues[selectModelKey].includes(signalKey);
    }

    onCheckboxChange(selectModelKey: string, signalKey: string, event: Event): void {
        const isChecked = (event.target as HTMLInputElement).checked;
        // Ottieni il valore corrente del formControl
        let currentModel = this.formControl.value as { [key: string]: string[] };

        // Se il valore è null o undefined, inizializzalo come oggetto vuoto
        if (!currentModel) {
            currentModel = {};
        }

        // Assicurati che l'array per questo selectModel esista
        if (!currentModel[selectModelKey]) {
            currentModel[selectModelKey] = [];
        }

        if (isChecked) {
            // Aggiungi il signalKey se non è già presente
            if (!currentModel[selectModelKey].includes(signalKey)) {
                currentModel[selectModelKey].push(signalKey);
            }
        } else {
            // Rimuovi il signalKey
            currentModel[selectModelKey] = currentModel[selectModelKey].filter(s => s !== signalKey);
            if (currentModel[selectModelKey].length === 0) {
                delete currentModel[selectModelKey];
            }
        }

        this.formControl.setValue({ ...currentModel });
    }

    toggleModel(modelKey: string): void {
        this.activeModel = this.activeModel === modelKey ? null : modelKey;
    }
}